import apiClient from '@lib/apiClient';
import { ListSystemLicensesQuery, ListSystemLicensesResponse, } from '@features/systems/domain/systemLicenses.types';

const API_BASE_URL = '/system-licenses';

// DON'T CALL THIS DIRECTLY FROM CODE - IT SHOULD ONLY BE CALLED BY `systemLicensesQueries` (systemLicensesService would be private if possible)
export const systemLicensesService = {
  listSystemLicenses: async (query: ListSystemLicensesQuery): Promise<ListSystemLicensesResponse> => {
    const response = await apiClient.get<ListSystemLicensesResponse>(
      API_BASE_URL,
      {params: query}
    );
    return response.data;
  },
};